import { createSelector } from "@reduxjs/toolkit";

const EMPTY_MODULE_FILTERS = {};

const selectFiltersState = (state) => state.filters ?? {};

export const selectModuleFilters = createSelector(
  [selectFiltersState, (_state, moduleKey) => moduleKey],
  (filtersState, moduleKey) => filtersState[moduleKey] ?? EMPTY_MODULE_FILTERS
);

export const selectFilter = createSelector(
  [
    selectFiltersState,
    (_state, moduleKey) => moduleKey,
    (_state, _moduleKey, key) => key,
  ],
  (filtersState, moduleKey, key) => filtersState[moduleKey]?.[key]
);

export const hasActiveFilters = createSelector(
  [selectModuleFilters],
  (moduleFilters) =>
    Object.values(moduleFilters).some(
      (value) => value !== null && value !== undefined && value !== ""
    )
);

export const activeFilterCount = createSelector(
  [selectModuleFilters],
  (moduleFilters) =>
    Object.values(moduleFilters).filter(
      (value) => value !== null && value !== undefined && value !== ""
    ).length
);
